import { render } from "./FanFact.vue?vue&type=template&id=b1eb10a2&ts=true"
import script from "./FanFact.vue?vue&type=script&lang=ts"
export * from "./FanFact.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__